import { c as _c } from "react/compiler-runtime";
import type { GetHistoryCategory, GetHistoryFilters } from '@repo/schema/history';
import { InputGroup, InputGroupAddon, InputGroupInput, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui/components';
import { Search } from '@repo/ui/icons';
import { HISTORY_ALL_CATEGORIES } from './history-constants.ts';
import { HistoryUserFilter } from './history-user-filter.tsx';
type HistoryFiltersProps = {
  category?: GetHistoryCategory;
  filters: GetHistoryFilters;
  onCategoryChange: (_category: GetHistoryCategory | undefined) => void;
  onSearchChange: (_search: string) => void;
  onUserChange: (_userId: number | undefined) => void;
  search: string;
  userId?: number;
};
export const HistoryFilters = t0 => {
  const $ = _c(32);
  const {
    category,
    filters,
    onCategoryChange,
    onSearchChange,
    onUserChange,
    search,
    userId
  } = t0;
  const categoryOptions = filters.categories;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      label: "All categories",
      value: HISTORY_ALL_CATEGORIES
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== categoryOptions) {
    t2 = [t1, ...categoryOptions];
    $[1] = categoryOptions;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const categoryItems = t2;
  let t3;
  if ($[3] !== onCategoryChange) {
    t3 = value => onCategoryChange(value === HISTORY_ALL_CATEGORIES ? undefined : value ?? undefined);
    $[3] = onCategoryChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = category ?? HISTORY_ALL_CATEGORIES;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SelectTrigger aria-label="All categories" className="w-full @xl/card-header:w-[132px]" data-sentry-element="SelectTrigger" data-sentry-source-file="history-filters.tsx"><SelectValue data-sentry-element="SelectValue" data-sentry-source-file="history-filters.tsx" /></SelectTrigger>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SelectItem value={HISTORY_ALL_CATEGORIES} data-sentry-element="SelectItem" data-sentry-source-file="history-filters.tsx">All categories</SelectItem>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== categoryOptions) {
    t7 = categoryOptions.map(_temp);
    $[7] = categoryOptions;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <SelectContent className="w-[216px] p-1" data-sentry-element="SelectContent" data-sentry-source-file="history-filters.tsx">{t6}{t7}</SelectContent>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== categoryItems || $[12] !== t3 || $[13] !== t4 || $[14] !== t8) {
    t9 = <Select items={categoryItems} onValueChange={t3} value={t4} data-sentry-element="Select" data-sentry-source-file="history-filters.tsx">{t5}{t8}</Select>;
    $[11] = categoryItems;
    $[12] = t3;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== filters.users || $[17] !== onUserChange || $[18] !== userId) {
    t10 = <HistoryUserFilter onUserChange={onUserChange} userId={userId} users={filters.users} data-sentry-element="HistoryUserFilter" data-sentry-source-file="history-filters.tsx" />;
    $[16] = filters.users;
    $[17] = onUserChange;
    $[18] = userId;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== onSearchChange) {
    t11 = event => onSearchChange(event.target.value);
    $[20] = onSearchChange;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== search || $[23] !== t11) {
    t12 = <InputGroupInput aria-label="Search history" maxLength={100} onChange={t11} placeholder="Search" value={search} data-sentry-element="InputGroupInput" data-sentry-source-file="history-filters.tsx" />;
    $[22] = search;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <InputGroupAddon align="inline-end" data-sentry-element="InputGroupAddon" data-sentry-source-file="history-filters.tsx"><Search aria-hidden="true" data-sentry-element="Search" data-sentry-source-file="history-filters.tsx" /></InputGroupAddon>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12) {
    t14 = <InputGroup className="min-w-0 flex-1 @3xl/card-header:w-[215px] @3xl/card-header:flex-none" data-sentry-element="InputGroup" data-sentry-source-file="history-filters.tsx">{t12}{t13}</InputGroup>;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14 || $[30] !== t9) {
    t15 = <div className="flex flex-col gap-2 @xl/card-header:flex-row @xl/card-header:items-center" data-sentry-component="HistoryFilters" data-sentry-source-file="history-filters.tsx">{t9}{t10}{t14}</div>;
    $[28] = t10;
    $[29] = t14;
    $[30] = t9;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
};
function _temp(option) {
  return <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>;
}